import BottomSheetModal from '@/components/modules/modals/BottomSheetModal';
import Modal from '@/components/modules/modals/redesign/Modal/Modal';
import useMobileView from '@/hooks/useMobileView';
import { _t } from '@/locale';
import AppDownloadPrompt from './AppDownloadPrompt';

const baseTranslationKey = 'features.app-download-prompt';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

/** Offers the app instead of a login when a logged-out visitor tries to save a company as a favourite. */
const AppDownloadPromptModal = ({ isOpen, onClose }: Props) => {
  const { isMobileView } = useMobileView();
  const title = _t(`${baseTranslationKey}.favouriteModal.title`);

  if (isMobileView) {
    return (
      <BottomSheetModal isOpen={isOpen} onClose={onClose} title={title}>
        <div className="pb-3xl flex-1 overflow-y-auto">
          <AppDownloadPrompt screenName="place_details" />
        </div>
      </BottomSheetModal>
    );
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose}>
      {/* No gutter: the floating modal is exactly as wide as the prompt it holds. */}
      <Modal.Content newDesign floating wrapperStyle={{ padding: 0 }}>
        <Modal.Header newDesign floating title={title} onClose={onClose} />
        <AppDownloadPrompt screenName="place_details" />
      </Modal.Content>
    </Modal>
  );
};

export default AppDownloadPromptModal;
